import type { ProviderGetImage } from '@nuxt/image';

/**
 * It will give back the original src you provided to the image.
 * Use it when you don't want to perform any optimization in development.
 */
export const getImage: ProviderGetImage = src => ({
  url: src,
});
